import React from 'react';
import { OverlayView } from '@react-google-maps/api';
import { WalkTime } from '../WalkTime';

interface Props {
  position: google.maps.LatLng;
  walkTime: number;
}

export const WalkTimeOverlay: React.FC<Props> = ({ position, walkTime }) => {
  console.log('Rendering WalkTimeOverlay:', { position: position.toJSON(), walkTime });

  return (
    <OverlayView position={position} mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}>
      <div
        style={{
          position: 'absolute',
          transform: 'translate(-50%, -50%)', // Add background to ensure visibility
          padding: '2px',
          borderRadius: '4px',
        }}
      >
        <WalkTime walkTime={walkTime} />
      </div>
    </OverlayView>
  );
};
